/**
 * Help Desk shared constants for views, status, sort, and priority labels.
 */

export const HELP_DESK_VIEWS = [
  { value: 'assigned_to_me', labelKey: 'help_desk_your_inbox' },
  { value: 'mentions', labelKey: 'help_desk_mentions' },
  { value: 'all', labelKey: 'help_desk_all_tickets' }
];

export const HELP_DESK_STATUS_OPTIONS = [
  { value: 'OPEN', labelKey: 'help_desk_open' },
  { value: 'RESOLVED', labelKey: 'help_desk_resolved' },
  { value: 'SNOOZED', labelKey: 'help_desk_snoozed' },
  { value: 'CLOSED', labelKey: 'help_desk_closed' }
];

export const HELP_DESK_SORT_OPTIONS = [
  { value: 'last_message_at_desc', labelKey: 'help_desk_sort_newest' },
  { value: 'last_message_at_asc', labelKey: 'help_desk_sort_oldest' },
  { value: 'priority_desc', labelKey: 'help_desk_sort_priority' },
  { value: 'priority_asc', labelKey: 'help_desk_sort_priority_asc' }
];

export const HELP_DESK_DEFAULT_VIEW = HELP_DESK_VIEWS[0].value;
export const HELP_DESK_DEFAULT_STATUS = HELP_DESK_STATUS_OPTIONS[0].value;
export const HELP_DESK_DEFAULT_SORT = HELP_DESK_SORT_OPTIONS[0].value;

export const HELP_DESK_STATUSES = {
  OPEN: 'OPEN',
  SNOOZED: 'SNOOZED',
  CLOSED: 'CLOSED'
};

export const HELP_DESK_PRIORITIES = {
  NONE: 'NONE',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};

export const HELP_DESK_VIEW_VALUES = {
  ASSIGNED_TO_ME: 'assigned_to_me',
  MENTIONS: 'mentions',
  ALL: 'all'
};

export const HELP_DESK_MESSAGE_TYPES = {
  MESSAGE: 'MESSAGE',
  INTERNAL_NOTE: 'INTERNAL_NOTE',
  SYSTEM_EVENT: 'SYSTEM_EVENT'
};

export const HELP_DESK_SENDER_TYPES = {
  ADMIN: 'admin',
  EMPLOYEE: 'employee'
};

export const HELP_DESK_PRIORITY_LABEL_KEYS = {
  NONE: 'help_desk_priority_none',
  LOW: 'help_desk_priority_low',
  MEDIUM: 'help_desk_priority_medium',
  HIGH: 'help_desk_priority_high'
};

export const HELP_DESK_TICKET_BADGES = {
  NEW: 'new',
  PENDING: 'pending'
};

export const HELP_DESK_INTERNAL_NOTE_COLORS = {
  background: '#FFEBC7',
  border: 'rgba(255, 152, 0, 0.2)',
  hoverBorder: '#E68900'
};

export const HELP_DESK_UNREAD_COLORS = {
  background: '#FFF0F0',
  text: '#FF3F97'
};

export const HELP_DESK_CATEGORY_COLORS = {
  default: '#5856D6',
  defaultBackground: '#EDEDFC'
};

export const HELP_DESK_RESOLVED_COLORS = {
  text: '#10B07C',
  background: '#E8F8F2'
};

export const DEFAULT_RESOLUTION_TIMEOUT_HOURS = 24;
